import { NSARouterMakerResult } from "namirasoft-account-react";
import { LoadBalancerTargetRow } from "namirasoft-inference";
import { Component } from "react";
import { InferenceRouterProps } from "../InferenceRouterProps";
import LoadBalancerTargetsView from "./LoadBalancerTargetsView";

interface LoadBalancerTargetsViewLoaderProps extends NSARouterMakerResult, InferenceRouterProps
{
	load_balancer_id: string;
}

interface LoadBalancerTargetsViewLoaderState
{
	rows: LoadBalancerTargetRow[] | null;
}

export default class LoadBalancerTargetsViewLoader extends Component<LoadBalancerTargetsViewLoaderProps, LoadBalancerTargetsViewLoaderState>
{
	override state: LoadBalancerTargetsViewLoaderState = { rows: null };

	override componentDidMount(): void { this.load(); }

	override componentDidUpdate(prev: LoadBalancerTargetsViewLoaderProps): void
	{
		if (prev.load_balancer_id !== this.props.load_balancer_id)
			this.load();
	}

	private async load(): Promise<void>
	{
		let { load_balancer_id: id } = this.props;
		if (!id) { this.setState({ rows: null }); return; }
		try
		{
			let row = await this.props.servers.inference.load_balancer.Get(id);
			this.setState({ rows: row.targets ?? [] });
		}
		catch (e) { console.error(e); }
	}

	override render()
	{
		let { rows } = this.state;
		if (!rows)
			return null;
		return (
			<LoadBalancerTargetsView
				{...this.props}
				load_balancer_id={this.props.load_balancer_id}
				rows={rows}
			/>
		);
	}
}